import { convertPhToISODate } from '~shared/lib/convert-date';

import { formatDocumentToApiDocument } from './document-to-api-document';
import { formatOptionalField } from './format-optional-field';

import type {
  ApplicationData,
  CompanyCategory,
  ApplicationFormValues,
} from '../../model';

const BRAND_ICON_TYPE = 'BRAND_ICON' as const;

function mapCompanyCategories(ids: string[]): CompanyCategory[] {
  return ids.map((id) => ({ id }));
}

export function formatBusinessInfo(
  data: ApplicationData,
  values: Partial<ApplicationFormValues>['businessInfo']
): ApplicationData {
  if (!values) return data;

  return {
    ...data,
    businessInfo: {
      registeredBusinessName: values.registeredBusinessName,
      registrationDate: convertPhToISODate(values.registrationDate),
      tinCode: values.tinCode,
      brandName: values.brandName,
      ...(values.brandIcon && {
        brandIcon: formatDocumentToApiDocument(
          values.brandIcon,
          BRAND_ICON_TYPE
        ),
      }),
      otherFinancingPartners: values.otherFinancingPartners,
      companyCategories: mapCompanyCategories(values.companyCategories),
      companyCategoryOther: formatOptionalField(values.companyCategoryOther),
    },
  };
}
